import { connect } from 'react-redux'
import MaintenanceCardsComponent from '../components/MaintenanceCardsComponent.jsx';
import {
	forwardToReloadMaintenanceCase,
	forwardToFindMaintenanceCards,
	forwardToSetMaintenanceTargetCard,
	forwardToFindCategories,
	forwardToEvaluateMaintenanceStatistic,
	forwardToGenerateMaintenanceCheckFileMap,
	forwardToCleanMcardsAlert,
	forwardToSortMaintenanceCards,
	forwardToSetMaintenanceCaseChecking,
	forwardToSetMaintenanceCaseModified,
	forwardToResetCheckFileLink,
	forwardToSetFilterString,
	forwardToResortingMCardsByCriteria,
	resetCardCategory
} from '../actions';

const mapStateToProps = (state) => ({

	//view model
	mCardListViewModel: state.getIn(['maintenanceCardsReducer', 'mCardListViewModel']),
	//request: current page
	mCardListRequestModel: state.getIn(['maintenanceCardsReducer', 'mCardListRequestModel']),

	//request: previous page
	mCaseListRequestModel: state.getIn(['maintenanceCasesReducer', 'mCaseListRequestModel']),

	alert: state.getIn(['maintenanceCardsReducer', 'alert']),

	files: state.getIn(['maintenanceCasesReducer', 'files']),

})

const mapDispatchToProps = (dispatch) => ({
	sortCards:( cards, order) =>{
		dispatch(forwardToSortMaintenanceCards(cards, order));
	},

	clearAlert: () => {
		dispatch(forwardToCleanMcardsAlert());
	},

	evaluateMaintenanceStatistic: (casePk) => {
		dispatch(forwardToEvaluateMaintenanceStatistic(casePk));
	},

	reloadMaintenanceCase: (casePk) => {
		dispatch(forwardToReloadMaintenanceCase(casePk));
	},
	findMaintenanceCards: (casePk, tabskey) => {
		if (tabskey == 0) {
			//待清點
			dispatch(forwardToFindMaintenanceCards({casePk: casePk, 
				       cardStatuss: ['WORKING','CHECKING'
					                   //,'PANT_CHECKED','CLOTH_CHECKED','COMPLETED'
									]} ));
		}
		if (tabskey == 1) {
			//修改清點單
			dispatch(forwardToFindMaintenanceCards({casePk: casePk, cardStatuss: ['COMPLETED']} ));
		}
		if (tabskey == 3) {
			//完工後拍照
			dispatch(forwardToFindMaintenanceCards({casePk: casePk, cardStatuss: ['COMPLETED']} ));
		}
	},

	setTargetCard: (id) => {
		dispatch(forwardToSetMaintenanceTargetCard({
			cardId: id
		}));
		dispatch(resetCardCategory());
	},

	findCategories: () => {
		dispatch(forwardToFindCategories())
	},

	generateMaintenanceCheckFileMap: (casePk) => {
		dispatch(forwardToGenerateMaintenanceCheckFileMap(casePk))
	},

	setFilterString: (filterString) => {
		dispatch(forwardToSetFilterString(filterString))
	},

	setMaintenanceCaseChecking: (casePk) => {
		dispatch(forwardToSetMaintenanceCaseChecking(casePk))
	},

	setMaintenanceCaseModified: (casePk) => {
		dispatch(forwardToSetMaintenanceCaseModified(casePk))
	},

	resetCheckFileLink:(casePk)=>{
		dispatch(forwardToResetCheckFileLink(casePk))
	},

	resortingMCardsByCriteria: (cards, criteria) => {
		dispatch(forwardToResortingMCardsByCriteria(cards, criteria));
	}
})

const MaintenanceCardsContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceCardsComponent)

export default MaintenanceCardsContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceCardsContainer.jsx